<template>
  <wui-modal
    :title="`${$t('common.outgoingCall')}: ${$t('common.connection')} ...`"
    :size="40"
    :closable="true"
    class="!w-[440px] phone:!w-4/5"
    @close="cancel"
  >
    <div class="grid justify-items-center">
      <p class="my-6 text-2432">
        {{ $t('common.dialingNumber') }} ...
      </p>
      <dots-loader class="mb-4" />
    </div>

    <template #footer>
      <wui-btn
        variant="negative"
        state="filled"
        icon
        class="grow"
        prepend-icon="phoneDownF"
        data-test="initial-dialog-cancel-button"
        @click="cancel"
      >
        <span class="sr-only select-none">{{ $t('common.rejectCall') }}</span>
      </wui-btn>
    </template>
  </wui-modal>
</template>

<script lang="ts" setup>
import { closeDialogKey, safeInject, WuiBtn, WuiModal } from '@wui/common-library'

import { DotsLoader } from '@/shared/components/loaders'
import { RTCSessionFacade } from '@/shared/services/jssip'

const props = defineProps<{
  rtcSessionFacade: RTCSessionFacade;
}>()

const closeDialog = safeInject(closeDialogKey)

const cancel = () => {
  closeDialog(true)
  props.rtcSessionFacade.terminate()
}
</script>
